import React from 'react';

import SuccessIcon from './successIcon';

import './index.css';

const SuccessSpinner: React.FC = () => {
    return (
        <div className="success-spinner-wrapper">
            <SuccessIcon className="success-spinner" />
        </div>
    );
};

export default SuccessSpinner;
